module.exports = __webpack_public_path__ + "static/img/uploadify1.4717b86.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/uploadify1.png
// module id = 872
// module chunks = 0